// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__17pow","additionalInfo":"AgreementModal_additionalInfo__2XxVt"};